(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dm-compare-nav"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{document.querySelectorAll('.dm-compare-nav details[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;});});
 document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('.dm-compare-nav details[open]').forEach(menu=>{if(menu.contains(document.activeElement))menu.querySelector('summary').focus();menu.open=false;});}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dragonmoss-home-product-finder"] && !Shopify.designMode) return;
  try {
    class DragonMossProductFinder {
    constructor(root) {
      this.root = root;
      this.grid = root.querySelector('[data-finder-grid]');
      this.cards = Array.from(root.querySelectorAll('[data-finder-card]'));
      this.search = root.querySelector('[data-finder-search]');
      this.sort = root.querySelector('[data-finder-sort]');
      this.count = root.querySelector('[data-finder-count]');
      this.empty = root.querySelector('[data-finder-empty]');
      this.more = root.querySelector('[data-finder-more]');
      this.clear = root.querySelector('[data-finder-clear]');
      this.category = 'all';
      this.pet = 'all';
      this.pageSize = 12;
      this.visibleLimit = this.pageSize;
      this.bind();
      this.render(false);
    }

    bind() {
      this.root.querySelectorAll('[data-category]').forEach((button) => {
        button.addEventListener('click', () => {
          this.category = button.dataset.category;
          this.setActive('[data-category]', button);
          this.visibleLimit = this.pageSize;
          this.render();
        });
      });

      this.root.querySelectorAll('[data-pet]').forEach((button) => {
        button.addEventListener('click', () => {
          this.pet = button.dataset.pet;
          this.setActive('[data-pet]', button);
          this.visibleLimit = this.pageSize;
          this.render();
        });
      });

      this.search.addEventListener('input', () => {
        this.visibleLimit = this.pageSize;
        this.render();
      });

      this.sort.addEventListener('change', () => this.render());

      this.more.addEventListener('click', () => {
        this.visibleLimit += this.pageSize;
        this.render();
      });

      this.clear.addEventListener('click', () => {
        this.category = 'all';
        this.pet = 'all';
        this.search.value = '';
        this.sort.value = 'featured';
        this.visibleLimit = this.pageSize;
        this.setActive('[data-category]', this.root.querySelector('[data-category="all"]'));
        this.setActive('[data-pet]', this.root.querySelector('[data-pet="all"]'));
        this.render();
      });
    }

    setActive(selector, activeButton) {
      this.root.querySelectorAll(selector).forEach((button) => {
        const active = button === activeButton;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    }

    matches(card) {
      const term = this.search.value.trim().toLowerCase();
      const categoryMatch = this.category === 'all' || card.dataset.category === this.category;
      const petMatch = this.pet === 'all' || card.dataset.pets.split(' ').includes(this.pet);
      const searchMatch = term === '' || card.dataset.title.includes(term);
      return categoryMatch && petMatch && searchMatch;
    }

    sortCards(cards) {
      const sort = this.sort.value;
      return cards.sort((a, b) => {
        if (sort === 'price-ascending') return Number(a.dataset.price) - Number(b.dataset.price);
        if (sort === 'price-descending') return Number(b.dataset.price) - Number(a.dataset.price);
        if (sort === 'title-ascending') return a.dataset.title.localeCompare(b.dataset.title);
        return Number(a.dataset.featuredOrder) - Number(b.dataset.featuredOrder);
      });
    }

    render(animate = true) {
      const update = () => {
        const matched = this.sortCards(this.cards.filter((card) => this.matches(card)));
        const unmatched = this.cards.filter((card) => !matched.includes(card));
        this.grid.append(...matched, ...unmatched);

        matched.forEach((card, index) => {
          card.hidden = index >= this.visibleLimit;
        });
        unmatched.forEach((card) => {
          card.hidden = true;
        });

        this.count.textContent = String(matched.length);
        this.empty.hidden = matched.length !== 0;
        this.more.hidden = matched.length <= this.visibleLimit;
      };

      if (animate && document.startViewTransition) {
        document.startViewTransition(update);
      } else {
        update();
      }
    }
  }

  const initializeDragonMossProductFinders = () => {
    document.querySelectorAll('[data-dm-product-finder]:not([data-finder-initialized])').forEach((root) => {
      root.setAttribute('data-finder-initialized', 'true');
      new DragonMossProductFinder(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeDragonMossProductFinders);
  } else {
    initializeDragonMossProductFinders();
  }

  document.addEventListener('shopify:section:load', initializeDragonMossProductFinders);
  } catch(e) { console.error(e); }
})();

})();
